import { defineComponent } from 'vue';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import { createPinia } from 'pinia';

let gfaqiddeplier: number;
gfaqiddeplier = 0;


const mixin = defineComponent({

    mounted() {
        this.DeplierFaq(gfaqiddeplier);
    },
    methods: {
        DeplierFaq(id: number) {
            let section = $("#dcfaq_response_" + id);
            if (section.css("display")=="none") {
                section.css("display", "block");
            }
            else {
                section.css("display", "none");
            }
        }
    }
});


export class FaqComponent {
   
    public Init(id: number) {
        gfaqiddeplier = id;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.mount('#rootpage');
    }
}
(<any>(window)).FaqComponent = function () { return new FaqComponent(); };